document.addEventListener('DOMContentLoaded', function() {
  const popup = document.querySelector('.b2b-b2c-popup');
  const privateBtn = document.querySelector('.button-private');
  const businessBtn = document.querySelector('.button-business');
  const defaultCustomerType = window.defaultCustomerType || 'private';

  function setUserType(type, fromUser = false) {
    if (fromUser) {
      localStorage.setItem('userType', type);
      closePopup();
    }


    document.body.classList.toggle('prices-without-taxes', type === 'business');
    updateLabelClasses(type);
    waitForTaxSwitcherLabels(type);
    updateVisiblePrices(type);
  }

  function updateLabelClasses(type) {
    const taxLabels = document.querySelectorAll('.tax-switcher__label');
    taxLabels.forEach(label => {
      label.classList.toggle('active', label.dataset.type === type);
    });
  }

  function updateVisiblePrices(type) {
    const businessPrices = document.querySelectorAll('.js-business-user');
    const privatePrices = document.querySelectorAll('.js-private-user');

    businessPrices.forEach(el => el.classList.remove('show-price'));
    privatePrices.forEach(el => el.classList.remove('show-price'));

    if (type === 'business') {
      businessPrices.forEach(el => el.classList.add('show-price'));
    } else {
      privatePrices.forEach(el => el.classList.add('show-price'));
    }
  }

  function waitForTaxSwitcherLabels(type) {
    const observer = new MutationObserver(() => {
      const labels = document.querySelectorAll('.tax-switcher__label');
      if (labels.length) {
        updateLabelClasses(type);
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function closePopup() {
    if (popup) {
      popup.style.display = 'none';
      popup.classList.remove('is-active');
    }
    document.body.classList.remove('popup-open');
  }

  function openPopup() {
    if (popup) {
      popup.style.display = 'block';
      popup.classList.add('is-active');
      document.body.classList.add('popup-open');
    }
  }

  const storedUserType = localStorage.getItem('userType');

  if (storedUserType === 'business') {
    setUserType('business', false);
  } else if (storedUserType === 'private') {
    setUserType('private', false);
  } else {
    setUserType(defaultCustomerType, false);
    openPopup();
  }

  if (privateBtn) privateBtn.addEventListener('click', () => setUserType('private', true));
  if (businessBtn) businessBtn.addEventListener('click', () => setUserType('business', true));

  const switcherLabels = document.querySelectorAll('.switcher__label, .tax-switcher__label');
  switcherLabels.forEach(label => {
    label.addEventListener('click', () => {
      const type = label.dataset.type;
      if (type) {
        setUserType(type, true);
      }
    });
  });

  const priceContainers = document.querySelectorAll(
    'cart-drawer, product-recommendations, predictive-search, #ProductGridContainer'
  );

  priceContainers.forEach(container => {
    const priceObserver = new MutationObserver(() => {
      const type = localStorage.getItem('userType') || defaultCustomerType;
      updateVisiblePrices(type);
    });

    priceObserver.observe(container, {
      childList: true,
      subtree: true
    });
  });

  window.setUserType = setUserType;
});
